import { Component, OnInit } from '@angular/core';
import { LoggingService } from '@EfsServices/logging.service';
import { GuardLinkService } from '@EfsServices/guard-link.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharingService } from '@EfsServices/data-sharing.service';
import { environment } from '@efsEnvironments/environment';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-initial-page',
    templateUrl: './initial-page.component.html',
    styleUrls: ['./initial-page.component.css'],
    standalone: false
})
export class InitialPageComponent implements OnInit {

  

  env = environment.envName;
  lockDown = false;
  bannerMessage = 'Maintenance in progress, no changes will be saved for the next 4';

  browser;
  ieMessage = false;
  lockdownMsg = false;

  constructor(
    private loggingService: LoggingService,
    private guardLinkService: GuardLinkService,
    private router: Router,
    public dialog: MatDialog,
    private dataSharingService: DataSharingService,
    public permissionHandlingService: PermissionHandlingService,
  ) { }

  ngOnInit() {
    // console.log(this.raWrite + ' ' + this.permissionHandlingService.raWrite);
    this.loggingService.logInfo('landed on Home page');
    sessionStorage.setItem('clientId', 'null');
    sessionStorage.setItem('clientNm', 'null');
    sessionStorage.setItem('fromCorp', 'null');
    sessionStorage.setItem('toCorp', 'null');
    sessionStorage.setItem('planType', 'null');
    this.specialNavigation();
    // check for browser, dont use ie for now
    this.browser = navigator.userAgent;
    console.log('browser is ' + this.browser);
    if (navigator.userAgent.indexOf('rv:11.0') !== -1) {
      console.log('ie detected!');
      this.ieMessage = true;
      this.lockdownMsg = false;
      this.lockDown = true;
    } else {
      console.log('not detected!');
    }
  }

  logNavigation(link) {
    this.loggingService.logInfo('pressed ' + link + ' link');
  }

  // navigate to a specific module if a condition is met, ie coming from a different program
  specialNavigation() {
    console.log('In SpecialNavigation Method');
    console.log(sessionStorage.getItem('callerId'));
    if (sessionStorage.getItem('callerId') === 'travellerSetup') {
      console.log('Calling NavigateTo Method');
      this.navigateTo('production setup');
    }
  }

  navigateTo(moduleName) { // validate the link and navigate. add any new modules here
    console.log('In NavigateTo Method');
    this.guardLinkService.validateLink().subscribe(() => {
      if (moduleName === 'setup') {
        console.log('Navigating to Setup');
        this.router.navigate(['setup']);
      }
      if (moduleName === 'nationalSetup') {
        console.log('Navigating to National setup');
        this.router.navigate(['nationalSetup']);
      }
      if (moduleName === 'clientSummary') {
        if (this.permissionHandlingService.permissionsMap.get('EFS-DASHBOARD READ') === true) {
          console.log('Navigating to National Dashboard');
          this.router.navigate(['clientSummary']);
          sessionStorage.setItem('fromInitialToND', 'true');
        } else {
          this.popupWarning(false, 'Access Denied! Please open a ticket to request access to EFS National Dashboard.');
        }
      }
      if (moduleName === 'production setup') {
        console.log('Navigating to production setup');
        this.router.navigate(['setup/productionSetup']);
        this.dataSharingService.shareData('modulePS');
      }
      if (moduleName === 'roleAdmin') {
        console.log('Navigating to roleAdmin');
        this.router.navigate(['roleAdmin']);
        this.dataSharingService.shareData('moduleRA');
      }
      if (moduleName === 'singleUserSetupICC') {
        console.log('Navigating to singleUserSetupICC');
        this.router.navigate(['singleUserSetupICC']);
        this.dataSharingService.shareData('singleUserSetupICC');
      }
      if (moduleName === 'mailerIdSetup') {
        console.log('Navigating to mailerIdSetup');
        this.router.navigate(['mailerIdSetup']);
        this.dataSharingService.shareData('mailerIdSetup');
      }
      if (moduleName === 'corpSlaExportReport') {
        console.log('Navigating to corpSlaExportReport');
        this.router.navigate(['corpSlaExportReport']);
        this.dataSharingService.shareData('moduleCSER');
      }
    });
  }

  popupWarning(questionType, message) {
    const popupDialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      height: '250px',
      panelClass: 'popup-borders',
      data: {
        questionType,
        title: 'Alert',
        message
      }
    });
    return true;
  }
}
